import styled from 'styled-components';
import { Button as SonarButton, Icon } from '@appcues/sonar';

export const BackButton = styled(SonarButton)`
  width: 16px;
  height: 22px;
  min-width: 16px;
  padding: 6px 8px;

  ${Icon} {
    color: var(--foreground-secondary);
  }

  &&&:hover {
    background-color: transparent;
  }
`;

export const ClearFilterButton = styled(SonarButton)`
  height: 22px;
  width: 50px;
  padding: 6px var(--spacing-regular);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-small);
`;
